import { Action, Reducer } from 'redux';
import { AppThunkAction } from '..';

import * as Models from '../../models/workflow/ApproveRejectWorkflowDashboard'

interface ApproveWorkflowDashboard {
    type: 'APPROVE_WORKFLOWDASHBOARD'
    response: Models.ResponseWorkflowDashboardApprove
    statusResponse: Number,
    statusMessage: String
}

interface ApproveWorkflowDashboardFail {
    type: 'APPROVE_WORKFLOWDASHBOARD_FAIL'
    statusResponse: number,
    statusMessage: any
}

interface ClearApproveWorkflowDashboard {
    type: 'CLEAR_APPROVE_WORKFLOWDASHBOARD'
    statusResponse: number,
    statusMessage: any
}

interface RejectWorkflowDashboard {
    type: 'REJECT_WORKFLOWDASHBOARD'
    response: Models.ResponseWorkflowDashboardApprove
    statusResponse: Number,
    statusMessage: String
}

interface RejectWorkflowDashboardFail {
    type: 'REJECT_WORKFLOWDASHBOARD_FAIL'
    statusResponse: number,
    statusMessage: any
}

interface ClearRejectWorkflowDashboard {
    type: 'CLEAR_REJECT_WORKFLOWDASHBOARD'
    statusResponse: number,
    statusMessage: any
}

type KnownAction = ApproveWorkflowDashboard | ApproveWorkflowDashboardFail | RejectWorkflowDashboard | RejectWorkflowDashboardFail | ClearApproveWorkflowDashboard | ClearRejectWorkflowDashboard

export const actionCreators = {
    requestApproveWorkflowDashboard: (p: boolean, method: String, userId: String, docNo: string, message: string, wf_type: string): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const appState = getState();
        console.log('call actionCreators : requestApproveWorkflowDashboard')
        if (appState && appState.approveRejectWorkflowDashboard && p && method == 'PUT') {
            var body = {
                'app_id': 'abcd',
                'user_id': userId,
                'doc_no': docNo,
                'message': message,
                'wf_type': wf_type
            }
            console.log(body)
            await fetch(`workflow/approve`, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('WF_APPLICATION'),
                },
                body: JSON.stringify(body),
            })
                .then(response => {
                    return response
                })
                .then((data) => {
                    console.log(data)
                    if (!data.ok) {
                        data.json().then(err => {
                            //console.log(err.message_res)
                            console.log('dispatch : APPROVE_WORKFLOWDASHBOARD_FAIL')
                            dispatch({ type: 'APPROVE_WORKFLOWDASHBOARD_FAIL', statusResponse: 300, statusMessage: err.message });
                        })
                    } else {
                        data.json().then(data => {
                            //console.log(data)
                            dispatch({ type: 'APPROVE_WORKFLOWDASHBOARD', response: data as Models.ResponseWorkflowDashboardApprove, statusResponse: 200, statusMessage: '' });
                        })
                    }
                })
        } else if (method == "CLEAR") {
            console.log('dispatch : CLEAR_APPROVE_WORKFLOWDASHBOARD')
            dispatch({ type: 'CLEAR_APPROVE_WORKFLOWDASHBOARD', statusResponse: 400, statusMessage: "" });
        }
    },
    requestRejectWorkflow: (p: boolean, method: String, userId: String, docNo: string, message: string, wf_type: string): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const appState = getState();
        console.log('call actionCreators : requestRejectWorkflow')
        if (appState && appState.approveRejectWorkflowDashboard && p && method == 'PUT') {
            var body = {
                'app_id': 'abc',
                'user_id': userId,
                'doc_no': docNo,
                'message': message,
                'wf_type': wf_type
            }
            console.log(body)
            await fetch(`/workflow/reject`, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('WF_APPLICATION'),
                },
                body: JSON.stringify(body),
            })
                .then(response => {
                    return response
                })
                .then((data) => {
                    console.log(data)
                    if (!data.ok) {
                        data.json().then(err => {
                            //console.log(err.message_res)
                            console.log('dispatch : REJECT_WORKFLOWDASHBOARD_FAIL')
                            dispatch({ type: 'REJECT_WORKFLOWDASHBOARD_FAIL', statusResponse: 400, statusMessage: err.message });
                        })
                    } else {
                        data.json().then(data => {
                            //console.log(data)
                            dispatch({ type: 'REJECT_WORKFLOWDASHBOARD', response: data as Models.ResponseWorkflowDashboardApprove, statusResponse: 200, statusMessage: '' });
                        })
                    }
                })
        } else if (method == "CLEAR") {
            console.log('dispatch : CLEAR_REJECT_WORKFLOWDASHBOARD')
            dispatch({ type: 'CLEAR_REJECT_WORKFLOWDASHBOARD', statusResponse: 400, statusMessage: "" });
        }
    },
    requestApproveWorkflowList: (p: boolean, method: String, wfList: any, message: string): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const appState = getState();
        console.log('call actionCreators : requestApproveWorkflow')
        if (appState && appState.approveRejectWorkflowDashboard && p && method == 'PUT') {
            var tasks: any = [];
            var finalResult: any;

            var body = wfList

            fetch(`v3/workflowdashboard/approve`, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('WF_APPLICATION'),
                },
                body: JSON.stringify(body),
            })
                .then((response) => {
                    return response
                })
                .then((data) => {
                    console.log(data)
                    if (!data.ok) {
                        data.json().then(err => {
                            console.log(err.message)
                            dispatch({ type: 'APPROVE_WORKFLOWDASHBOARD_FAIL', statusResponse: 204, statusMessage: err.message });
                        })
                            .catch((error) => {
                                dispatch({ type: 'APPROVE_WORKFLOWDASHBOARD_FAIL', statusResponse: 204, statusMessage: 'เกิดข้อผิดพลาด <br> กรุณาปิดหน้าต่าง Workflow แล้วทำรายการใหม่อีกครั้ง' });
                            });
                    } else {
                        data.json().then(data => {
                            console.log(data)
                            dispatch({ type: 'APPROVE_WORKFLOWDASHBOARD', response: data, statusResponse: 200, statusMessage: '' });
                        })
                    }
                });

        } else if (method == "CLEAR") {
            console.log('dispatch : CLEAR_APPROVE_WORKFLOWDASHBOARD')
            dispatch({ type: 'CLEAR_APPROVE_WORKFLOWDASHBOARD', statusResponse: 400, statusMessage: "" });
        }
    },
    requestRejectWorkflowList: (p: boolean, method: String, wfList: any, message: string, accessToken?: string): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const appState = getState();
        console.log('call actionCreators : requestRejectWorkflow')
        if (appState && appState.approveRejectWorkflowDashboard && p && method == 'PUT') {
            var tasks: any = [];
            var finalResult: any;

            var body = wfList
            console.log(JSON.stringify(body))

            const bearer = `Bearer ${accessToken || localStorage.getItem('WF_APPLICATION')}`;

            fetch(`v3/workflowdashboard/force-reject`, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': bearer,
                },
                body: JSON.stringify(body),
            })
                .then((response) => {
                    return response
                })
                .then((data) => {
                    console.log(data)
                    if (!data.ok) {
                        data.json().then(err => {
                            console.log(err.message)
                            dispatch({ type: 'REJECT_WORKFLOWDASHBOARD_FAIL', statusResponse: 204, statusMessage: err.message });
                        })
                            .catch((error) => {
                                dispatch({ type: 'REJECT_WORKFLOWDASHBOARD_FAIL', statusResponse: 204, statusMessage: 'เกิดข้อผิดพลาด <br> กรุณาปิดหน้าต่าง Workflow แล้วทำรายการใหม่อีกครั้ง' });
                            });
                    } else {
                        data.json().then(data => {
                            console.log(data)
                            dispatch({ type: 'REJECT_WORKFLOWDASHBOARD', response: data, statusResponse: 200, statusMessage: '' });
                        })
                    }
                });

        } else if (method == "CLEAR") {
            console.log('dispatch : CLEAR_REJECT_WORKFLOWDASHBOARD')
            dispatch({ type: 'CLEAR_REJECT_WORKFLOWDASHBOARD', statusResponse: 400, statusMessage: "" });
        }
    }
}

const unloadedState: Models.ApproveRejectWorkflowDashboardState = { isLoadApproveReject: false };

export const reducer: Reducer<Models.ApproveRejectWorkflowDashboardState> = (state: Models.ApproveRejectWorkflowDashboardState | undefined, incomingAction: Action): Models.ApproveRejectWorkflowDashboardState => {
    if (state == undefined) {
        return unloadedState;
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'APPROVE_WORKFLOWDASHBOARD':
            return {
                isLoadApproveReject: true,
                responseApproveReject: action.response,
                statusResponseApproveReject: action.statusResponse

            }
        case 'APPROVE_WORKFLOWDASHBOARD_FAIL':
            return {
                isLoadApproveReject: true,
                messageResponseApproveReject: action.statusMessage,
                statusResponseApproveReject: 400
            }
        case 'REJECT_WORKFLOWDASHBOARD':
            return {
                isLoadApproveReject: true,
                responseApproveReject: action.response,
                statusResponseApproveReject: action.statusResponse
            }
        case 'REJECT_WORKFLOWDASHBOARD_FAIL':
            return {
                isLoadApproveReject: true,
                messageResponseApproveReject: action.statusMessage,
                statusResponseApproveReject: 400
            }
        case 'CLEAR_APPROVE_WORKFLOWDASHBOARD':
            return {
                isLoadApproveReject: false,
                messageResponseApproveReject: "",
                statusResponseApproveReject: 0
            }
        case 'CLEAR_REJECT_WORKFLOWDASHBOARD':
            return {
                isLoadApproveReject: false,
                messageResponseApproveReject: "",
                statusResponseApproveReject: 0
            }
        default: return state;
    }
}